import { Lock, Eye, ShieldCheck, FileLock, Scale } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const ITEMS = [
  { icon: Lock, t: "Sigilo das informações", d: "Os dados da sua propriedade e da sua operação são tratados com confidencialidade." },
  { icon: Scale, t: "Anticorrupção e conflito de interesses", d: "Atuação íntegra, sem promessas indevidas e com gestão de conflitos de interesse." },
  { icon: ShieldCheck, t: "LGPD", d: "Tratamento de dados pessoais conforme a Lei Geral de Proteção de Dados." },
  { icon: FileLock, t: "Termo de confidencialidade e controle de acesso", d: "Documentos sob termo de confidencialidade e acesso controlado àqueles que precisam deles." },
];

export const Integrity = () => (
  <section data-testid="integrity-section" className="bg-[#F2EFE9] py-10 sm:py-14 md:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-start">
        <div className="lg:col-span-5">
          <Reveal><Overline>Compromisso e integridade</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-[#1A2218] sm:mt-8 sm:text-5xl lg:text-6xl">
              Independência técnica, confidencialidade e <em className="text-[#233D25]">comunicação objetiva.</em>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <ul className="grid grid-cols-2 gap-3 sm:gap-4 lg:block lg:space-y-4">
            {ITEMS.map((it, i) => (
              <Reveal key={it.t} delay={0.05 * i}>
                <li data-testid={`integrity-item-${i + 1}`} className="flex h-full items-start gap-3 rounded-[20px] border border-[#E5E0D5] bg-white p-3 sm:p-6 lg:gap-4">
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#F2EFE9] text-[#233D25] sm:h-10 sm:w-10">
                    <it.icon className="h-4 w-4 sm:h-5 sm:w-5" />
                  </span>
                  <div>
                    <p className="font-serif text-sm leading-snug text-[#1A2218] sm:text-lg lg:text-xl">{it.t}</p>
                    <p className="mt-1 line-clamp-3 text-xs leading-relaxed text-[#4A5549] sm:text-sm lg:line-clamp-none">{it.d}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
